// @flow

type SetWalletForfeitureDataPayload = {| dateToCallWalletForfeiture: string, walletForfeitureRevival: string |};

export type WalletActionType =
  | {|
      type: 'FETCH_WALLET_FORFEITURE_DATA',
    |}
  | {|
      type: 'SET_WALLET_FORFEITURE_DATA',
      payload: SetWalletForfeitureDataPayload,
    |};

export const fetchWalletForfeitureData = () => ({
  type: 'FETCH_WALLET_FORFEITURE_DATA',
});

export const setWalletForfeitureData = (payload: SetWalletForfeitureDataPayload) => ({
  type: 'SET_WALLET_FORFEITURE_DATA',
  payload,
});
